var refreshing;
var newWorker;
var deferredPrompt;
var bodyElement = $('body');

function pwaAppLoader(){
    if($('.pwa-app--loader')){
        $('.pwa-app--loader').fadeOut(100);
    }
}

setTimeout(function () {
    pwaAppLoader();
}, 10000);

if (!(
    window.matchMedia('(display-mode: standalone)').matches ||
    ('standalone' in window.navigator && window.navigator.standalone === true)
)) {
    if (navigator.userAgent && /iPhone/.test(navigator.userAgent)) {
        if (bodyElement.hasClass('pwa-app--main')) {
            $('.pwa_install_button').css('display', 'flex');
            pwaAppLoader();
        } else {
            $('#pwa_install_banner_ios').css('display', 'flex');
            pwaAppLoader();
        }
        bodyElement.addClass('has-install-banner has-install-banner-ios');
    }
}

function getChromeVersionForPwa() {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);

    return raw ? parseInt(raw[2], 10) : false;
}
var chromeVersionForPwa = getChromeVersionForPwa();
if (chromeVersionForPwa && chromeVersionForPwa <= 68) {
    if (bodyElement.hasClass('pwa-app--main')) {
        $('.pwa_install_button').css('display', 'flex');
        pwaAppLoader();
    } else {
        $('#pwa_install_banner_old_chrome').css('display', 'flex');
        pwaAppLoader();
    }
    bodyElement.addClass('has-install-banner');
}

jQuery(document).ready(function () {
    $(document).on('click', '#pwa_install_banner_close', function () {
        $('.pwa_install__banner').hide();
        bodyElement.removeClass('has-install-banner has-install-banner-ios');
    });

    if (bodyElement.hasClass('pwa-app--main')) {
        $(document).on('click', '.pwa_install_button', function () {
            var chromeVersionForPwa = getChromeVersionForPwa();
            if (!(
                window.matchMedia('(display-mode: standalone)').matches ||
                ('standalone' in window.navigator && window.navigator.standalone === true)
            )) {
                if (navigator.userAgent && /iPhone/.test(navigator.userAgent)) {
                    $('#pwa_install_banner_ios').css('display', 'flex');
                    pwaAppLoader();
                    bodyElement.addClass('has-install-banner has-install-banner-ios');
                }
            } else if (chromeVersionForPwa && chromeVersionForPwa <= 68) {
                $('#pwa_install_banner_old_chrome').css('display', 'flex');
                pwaAppLoader();
                bodyElement.addClass('has-install-banner');
            }
        });
    }
});

if ('serviceWorker' in navigator) {
    jQuery(document).ready(function () {
        $(document).on('click', '#pwa_reload', function () {
            newWorker.postMessage({action: 'skipWaiting'});
        });
    });

    navigator.serviceWorker.register('/v2/pwa/service-worker.js')
        .then(function (reg) {
            console.log('Service worker registered!', reg);

            reg.addEventListener('updatefound', function () {
                // An updated service worker has appeared in reg.installing!
                newWorker = reg.installing;

                newWorker.addEventListener('statechange', function () {

                    // Has service worker state changed?
                    if (newWorker.state === 'installed') {
                        if (navigator.serviceWorker.controller) {
                            $('#pwa_notification').css('display', 'flex');
                            pwaAppLoader();
                        }
                    }
                });
            });
        })
        .catch(function (err) {
            console.log('Service worker registration failed: ', err);
        });


    // The event listener that is fired when the service worker updates
    // Here we reload the page
    navigator.serviceWorker.addEventListener('controllerchange', function () {
        if (refreshing) return;
        window.location.reload();
        refreshing = true;
    });

    window.addEventListener('beforeinstallprompt', function (event) {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        event.preventDefault();

        // Stash the event so it can be triggered later.
        deferredPrompt = event;

        var btnForClick = bodyElement.hasClass('pwa-app--main')
            ? $('.pwa_install_button')
            : $('#pwa_install_banner_btn');
        // Attach the install prompt to a user gesture
        btnForClick.click(function (event) {
            // Show the prompt
            deferredPrompt.prompt();

            // Wait for the user to respond to the prompt
            deferredPrompt.userChoice
                .then(function (choiceResult) {
                    if (choiceResult.outcome === 'accepted') {
                        window.location.href = '/v2/pwa/?theme=pwa';
                    } else {
                        console.log('User dismissed the A2HS prompt');
                    }
                    deferredPrompt = null;
                });
        });

        // Update UI notify the user they can add to home screen
        bodyElement.addClass('has-install-banner');
        if (bodyElement.hasClass('pwa-app--main')) {
            $('.pwa_install_button').css('display', 'flex');
            pwaAppLoader();
        } else {
            $('#pwa_install_banner').css('display', 'flex');
            pwaAppLoader();
        }
        // $('#pwa_install_banner').css('display', 'flex');
    });
};
define("pwa", ["jquery"], function(){});

